import { SUPPORTED_VIDEO_CODECS } from '@anm/constants/supports';
import { Media } from '@anm/hosting-player';

const isSupportedCodec = (video: Media) => video.codec && SUPPORTED_VIDEO_CODECS.includes(video.codec);

export default isSupportedCodec;
